// extracted by mini-css-extract-plugin
export var allProducts = "style-mod--all-products--e8789";
export var bestProduct = "style-mod--best-product--47744";
export var bestProducts = "style-mod--best-products--a0d2a";
export var bpTitle = "style-mod--bp-title--bbcc5";
export var clipStar = "style-mod--clip-star--d922a";
export var products = "style-mod--products--80044";
export var productsDesc = "style-mod--products-desc--d493c";
export var publisher = "style-mod--publisher--bd71c";
export var publisherImg = "style-mod--publisher-img--280f0";
export var ratingDesc = "style-mod--rating-desc--24465";